
import { defineComponent, ref, onMounted } from 'vue'
import Icon from '@/components/base/Icon.vue'
import { IconType } from '@/enums/IconType'

interface Item {
  id: string
  name: string
}

export default defineComponent({
  name: 'SearchInput',
  components: {
    Icon,
  },
  emits: ['update:keyword'],
  props: {
    keyword: {
      type: String,
      default: '',
    },
    onClick: {
      type: Function,
      default: () => false,
    },
    placeholder: String,
    maxlength: Number,
    focus: Boolean,
  },
  setup(props) {
    const isFocus = ref(props.focus)
    const searchInput = ref()

    onMounted(() => {
      if (isFocus.value) {
        searchInput.value.focus()
      }
    })

    return {
      searchInput,
      isFocus,
      IconType,
    }
  },
})
